import { useQuery } from 'react-query';

import { GetSubsetPersonsResponse } from '../../../../backend/src/matter/subset/dto/response-get-subset-persons.dto';
import { PersonType } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface PersonFilters {
  types?: PersonType[];
}

interface GetSubsetPersonsProps {
  matterId: string;
  subsetId: string;
  searchQuery?: string;
  searchNameOnly?: boolean;
  page?: number;
  pageSize?: number;
  paginated: boolean;
  filters: PersonFilters;
}

export const useGetSubsetPersons = ({
  matterId,
  subsetId,
  searchQuery,
  searchNameOnly,
  page,
  pageSize,
  paginated,
  filters,
}: GetSubsetPersonsProps) => {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      searchNameOnly,
      page: page || 1,
      pageSize: pageSize || 25,
      paginated,
      types: filters.types,
    },
  });

  return useQuery<GetSubsetPersonsResponse, Error>(
    [QueryEntity.SubsetPersons, { subsetId, searchQuery, searchNameOnly, filters, page, pageSize, paginated }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons/query`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Failed to query subset persons');
      return response.json();
    },
    {
      enabled: !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
